/**
 * Add a custom filter (WHERE clause) to dashboard card queries.
 * Filters by account_id = online_acc_id from the logged-in user's login_attributes.
 */
export const ACCOUNT_ID_COLUMN_NAME = "account_id";

export const USER_ID_COLUMN_NAME = "col_user_id";

const HIDDEN_FROM_QUESTION_COLUMN_PICKERS = new Set([
  ACCOUNT_ID_COLUMN_NAME,
  USER_ID_COLUMN_NAME,
]);

/** Columns omitted from notebook/field/join column pickers (not query results). */
export function isColumnHiddenFromQuestionPickers(
  name: string | undefined,
  displayName?: string | undefined,
): boolean {
  if (name != null && HIDDEN_FROM_QUESTION_COLUMN_PICKERS.has(name)) {
    return true;
  }

  if (displayName != null) {
    const normalizedDisplayName = displayName
      .toLowerCase()
      .replace(/\s+/g, "_");
    if (HIDDEN_FROM_QUESTION_COLUMN_PICKERS.has(normalizedDisplayName)) {
      return true;
    }
  }

  return false;
}
